import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["dir"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputCore = _resolveComponent("InputCore")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", {
    dir: _ctx.dir,
    class: "w-100"
  }, [
    (_ctx.generalMethods.valueExist(_ctx.prop))
      ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: _ctx.hideLabel ? null : _ctx.generalMethods.translate(_ctx.label),
          for: _ctx.id == null ? _ctx.prop : _ctx.id,
          prop: _ctx.prop,
          rules: _ctx.rules,
          class: _normalizeClass(`${_ctx.elFormItemClassses}`),
          required: _ctx.required
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(_component_InputCore, {
              id: _ctx.id == null ? _ctx.prop : _ctx.id,
              modelValue: _ctx.localModelValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localModelValue) = $event)),
              autocomplete: _ctx.autocomplete,
              dir: _ctx.dir,
              onInput: _cache[1] || (_cache[1] = (value) => _ctx.emitEvent('input', value)),
              type: _ctx.generalMethods.valueExist(_ctx.type) ? _ctx.type : _ctx.generalMethods.valueExist(_ctx.rows) ? 'textarea' : 'text',
              rows: _ctx.rows,
              min: _ctx.min,
              label: _ctx.ariaLabel,
              disabled: _ctx.disabled,
              readonly: _ctx.readonly,
              placeholder: _ctx.placeholder,
              size: _ctx.size,
              inputmode: _ctx.inputmode,
              autofocus: _ctx.autofocus
            }, null, 8, ["id", "modelValue", "autocomplete", "dir", "type", "rows", "min", "label", "disabled", "readonly", "placeholder", "size", "inputmode", "autofocus"])
          ]),
          _: 2
        }, [
          (!_ctx.hideLabel)
            ? {
                name: "label",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "label")
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["label", "for", "prop", "rules", "class", "required"]))
      : (_openBlock(), _createBlock(_component_InputCore, {
          key: 1,
          id: _ctx.id == null ? _ctx.prop : _ctx.id,
          modelValue: _ctx.localModelValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModelValue) = $event)),
          autocomplete: _ctx.autocomplete,
          dir: _ctx.dir,
          onInput: _cache[3] || (_cache[3] = (value) => _ctx.emitEvent('input', value)),
          type: _ctx.generalMethods.valueExist(_ctx.type) ? _ctx.type : _ctx.generalMethods.valueExist(_ctx.rows) ? 'textarea' : 'text',
          rows: _ctx.rows,
          min: _ctx.min,
          label: _ctx.ariaLabel,
          disabled: _ctx.disabled,
          readonly: _ctx.readonly,
          placeholder: _ctx.placeholder,
          size: _ctx.size,
          inputmode: _ctx.inputmode,
          autofocus: _ctx.autofocus
        }, null, 8, ["id", "modelValue", "autocomplete", "dir", "type", "rows", "min", "label", "disabled", "readonly", "placeholder", "size", "inputmode", "autofocus"]))
  ], 8, _hoisted_1))
}